import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReturnNoteDialogOptions } from './returnnote-dialog';


@Component({
    selector: 'app-returnnote-dialog',
    templateUrl: './returnnote-dialog.component.html',
    styleUrls: ['./returnnote-dialog.component.scss']
})
export class ReturnNoteDialogComponent {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    ReturnNote?: string;

    constructor(
        private dialogRef: MatDialogRef<ReturnNoteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: ReturnNoteDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.OKText = opts.OKText || 'OK';
        self.CancelText = opts.CancelText || 'Cancel';
        self.ReturnNote = opts.ReturnNote || '';
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(this.ReturnNote);
    }
}
